import { observable } from 'mobx'
import ERROR_MSG from '../../constants/ERROR_MSG'
import dynamic from 'next/dynamic'

const CONSTS = dynamic(() => import('../../constants/CONSTS'), {
  ssr: false
})

/**
 * Author: Hanamantraya R
 * Class Name: UserValidate
 * Description: Validate the login inputs data
 */
export default class {
  @observable name = ''
  @observable label = ''
  @observable required = ''
  @observable value = ''
  @observable minLength = ''
  @observable maxLength = ''
  @observable errors = []

  /**
   * @Author: Hanamantraya R
   * @Method: constructor
   * @Param: String(name)
   * @Param: String(label)
   * @Param: Boolean(required)
   * @Param: String(value)
   * @Return: Void
   * Description: Nothing return
   */
  constructor (name, label, value = '', required = true, minLength = null, maxLength = null) {
    this.name = name
    this.label = label
    this.value = value
    this.required = required
    this.minLength = minLength
    this.maxLength = maxLength
  }

  /**
   * @Author: Hanamantraya R
   * @Method: validate
   * @Param: Empty
   * @Return: Void
   * Description: Validates the user inputs if error return valid error message else nothing
   */
  validate () {
    this.errors.replace([])
    switch (this.name) {
      case 'first_name':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_FIRST_NAME_VALIDATOR)
        }
        break
      case 'last_name':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_LAST_NAME_VALIDATOR)
        }
        break
      case 'firm_name':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_FIRM_NAME_VALIDATOR)
        }
        break
      case 'ria_name':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_RIA_NAME_VALIDATOR)
        }
        break
      case 'role_id':
        if (!this.value && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_ROLE_VALIDATOR)
        }
        break
      case 'partner_id':
        if (!this.value && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_PARTNER_VALIDATOR)
        }
        break
      case 'street_address1':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_ADDRESS1_VALIDATOR)
        }
        break
      case 'street_address2':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_ADDRESS2_VALIDATOR)
        }
        break
      case 'city':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_CITY_NAME_VALIDATOR)
        }
        break
      case 'state':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_STATE_NAME_VALIDATOR)
        }
        break
      case 'zip':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_ZIP_CODE_VALIDATOR)
        } else if (this.value.length > 0 && !CONSTS.ZIP_REGEXP.test(this.value)) {
          this.errors.push(ERROR_MSG.ERR_USER_INVALID_ZIP_CODE_VALIDATOR)
        } else if ((this.value.length < this.minLength || this.value.length > this.maxLength) && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_INVALID_ZIP_CODE_VALIDATOR)
        }
        break
      case 'broker_dealers':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_BROKER_DEALER_VALIDATOR)
        }
        break
      case 'custodians':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_CUSTODIANS_VALIDATOR)
        }
        break
      case 'aun':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_AUN_VALIDATOR)
        }
        break
      case 'job_title':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_JOB_TITLE_VALIDATOR)
        }
        break
      case 'industry':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_INDUSTRY_VALIDATOR)
        }
        break
      case 'number_of_employees':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_NUM_EMPLOYEES_VALIDATOR)
        } else if (this.value.length > 0 && !CONSTS.ZIP_REGEXP.test(this.value)) {
          this.errors.push(ERROR_MSG.ERR_USER_NUM_EMPLOYEES_INVALID_VALIDATOR)
        }
        break
      case 'arche_type':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_ARCH_VALIDATOR)
        }
        break
      case 'trailing_gdc':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_GDC_VALIDATOR)
        }
        break
      case 'total_households':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_USER_NUM_HOUSEHOLDS_VALIDATOR)
        }
        break
      case 'email':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_ENROL_EMAIL_REQ)
        } else if (this.value.length > 0 && !CONSTS.EMAIL_REGEXP.test(this.value)) {
          this.errors.push(ERROR_MSG.ERR_USER_EMAIL)
        }
        break
      case 'phone':
        if (!this.value.length && this.required) {
          this.errors.push(ERROR_MSG.ERR_ENROL_PHONE_REQ)
        } else if (this.value.length > 0 && !CONSTS.PHONE_REGEXP.test(this.value)) {
          this.errors.push(ERROR_MSG.ERR_USER_INVALID_PHONE_VALIDATOR)
        }
        break
      default:break
    }
  }
}
